import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "components/common/MenuItem";
import { ListItemText, Select } from "@mui/material";
import { InputLabel } from "@mui/material";

export default function VehicleVariantEditModel({
  open, 
  handleCloseEdit,
  selectlist,
  selecmodeltlist,
  model_id,
  name,
  manufacturer_id,
  handleOnChange,
  handleClickEditVehicleVariantSubmit,
  OnmanufactureChange,
}) {
  const [selectedVehicle, setSelectedVehicle] = React.useState(manufacturer_id);
  const [selectedModel, setSelectedModel] = React.useState(model_id);

  React.useEffect(() => {
    setSelectedVehicle(manufacturer_id);
    setSelectedModel(model_id);
  }, [manufacturer_id, model_id, open]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleCloseEdit}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "16px",
            lineHeight: "15px",
            display: "flex",
            alignItems: "center",
            color: "#111111",
            marginTop: "1.2rem",
          }}
        >
          {"Edit Vehicle Variant name"}
        </DialogTitle>
        <DialogContent>
          <InputLabel id="demo-simple-select-label">
            Select Vehicle Manufacturer
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            defaultValue={manufacturer_id}
            label="Age"
            style={{
              margin: "0 0 10px 0",
              padding: "10px 15px",
              width: "18.5rem",
              height: "2.8rem",
              background: "#FFFFFF",
              border: "1px solid #EBEBEB",
              borderRadius: "6px",
            }}
            // value={localManufacturerId}
            onChange={(vehicle) => {
              setSelectedVehicle(vehicle.target.value);
              OnmanufactureChange(vehicle.target.value);
            }}
          >
            {selectlist?.map((item) => (
              <MenuItem key={item} value={item.id}>
                <ListItemText primary={item.name} />
              </MenuItem>
            ))}
          </Select>

          <InputLabel id="demo-simple-select-label">
            Select Vehicle Model
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            defaultValue={model_id}
            label="Age"
            style={{
              margin: "0 0 10px 0",
              padding: "10px 15px",
              width: "18.5rem",
              height: "2.8rem",
              background: "#FFFFFF",
              border: "1px solid #EBEBEB",
              borderRadius: "6px",
            }}
            onChange={(model) => {
              setSelectedModel(model.target.value);
              handleOnChange(model, "model_id");
            }}
          >
            {selecmodeltlist?.map((item) => (
              <MenuItem key={item} value={item.id}>
                <ListItemText primary={item.name} />
              </MenuItem>
            ))}
          </Select>

          <InputLabel id="demo-simple-select-label">
            Enter Vehicle Variant Name
          </InputLabel>

          <DialogContentText>
            <input
              placeholder="Enter vehicle model name"
              style={{
                fontSize: "17px",
                margin: "0 0 10px 0",
                padding: "0px 28px",
                width: "15rem",
                height: "44px",
                background: "#FFFFFF",
                border: "1px solid #EBEBEB",
                borderRadius: "6px",
              }}
              defaultValue={name}
              onChange={(e) => {
                handleOnChange(e, "name");
              }}
              onInput={(e) => {
                e.target.value = e.target.value
                  .trimStart()
                  .replace(/[^a-zA-Z^0-9 ]*/g, "");
              }}
            ></input>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            sx={{
              background: "#04AAD",
              marginRight: "1rem",
              width: "100.17px",
              height: "40px",
              marginBottom: "1.2rem",
              cursor: "pointer",
              fontSize: "12px",
            }}
            autoFocus
            onClick={() => handleClickEditVehicleVariantSubmit(selectedVehicle, selectedModel)}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
